function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Tuy_Web_Icon");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M74.69,41.09H25.89a1.06,1.06,0,0,0-1.06,1.06v2.12a1.06,1.06,0,0,0,1.06,1.06h48.8a1.06,1.06,0,0,0,1.06-1.06V42.15A1.06,1.06,0,0,0,74.69,41.09Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M55.59,53.82H25.89a1.06,1.06,0,0,0-1.06,1.06V57a1.06,1.06,0,0,0,1.06,1.06h29.7A1.06,1.06,0,0,0,56.65,57V54.88A1.06,1.06,0,0,0,55.59,53.82Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55.59,66.55H25.89a1.06,1.06,0,0,0-1.06,1.06v2.12a1.06,1.06,0,0,0,1.06,1.06h29.7a1.06,1.06,0,0,0,1.06-1.06V67.61A1.06,1.06,0,0,0,55.59,66.55Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M74.69,28.36H32.25a1.06,1.06,0,0,0-1.06,1.06v2.12a1.06,1.06,0,0,0,1.06,1.06H74.69a1.06,1.06,0,0,0,1.06-1.06V29.42A1.06,1.06,0,0,0,74.69,28.36Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M74.69,51.7H66.2a5.3,5.3,0,0,0,0,10.61h1.06v7.43a1.06,1.06,0,1,0,2.12,0V53.82H71.5V69.73a1.06,1.06,0,0,0,2.12,0V53.82h1.06a1.06,1.06,0,1,0,0-2.12Z"
});

var SvgVocabulary = function SvgVocabulary(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVocabulary, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vocabulary.f6b2c5d0.svg";
export { ForwardRef as ReactComponent };